/**
 * @file: description
 * @author:
 * @Date: 2020-04-23 11:32:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-08 22:23:21
 */
import React, { useEffect, useCallback, useState } from 'react';
import ajax from '@ajax';
import Vditor from 'vditor';

import './SFCVditor.less';
import { FileDTO } from '@src/services';
import { message } from 'antd';
import { emojiObj } from './emoji';

type Props = ISFCVditorProps;
export interface ISFCVditorProps {
  className?: string;
  content?: string;
  changeVal: (val: string) => void;
}

const vditorOption: (IMenuItem | string)[] = [
  'emoji',
  'headings',
  'bold',
  'italic',
  'strike',
  'line',
  'quote',
  'list',
  'ordered-list',
  'check',
  'code',
  'inline-code',
  'outdent',
  'indent',
  'insert-before',
  'insert-after',
  'undo',
  'redo',
  {
    name: 'upload',
    tip: '上传图片',
    icon:
      '<svg t="1587108568931" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4504" width="200" height="200"><path d="M128 0h768a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128z m576 448a128 128 0 1 0 0-256 128 128 0 0 0 0 256z m-60.736 294.912a19.2 19.2 0 0 1-29.696-0.512L448 532.928a57.152 57.152 0 0 0-88.32 0l-220.672 279.296a50.624 50.624 0 0 0-11.008 31.36c0 28.992 24.704 52.416 55.168 52.416h657.664a57.088 57.088 0 0 0 34.432-11.52 50.56 50.56 0 0 0 8.64-73.6l-105.92-125.568a57.216 57.216 0 0 0-86.144 0l-48.576 57.6z" p-id="4505"></path></svg>'
  },
  'link',
  'table',
  'format',
  'edit-mode'
];

let vditor: Vditor | undefined = undefined;
const xss = require('xss');

export const SFCVditor = (props: Props) => {
  const { className = '', content = '', changeVal } = props;
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (vditor && isRendered && content) {
      vditor.setValue(content);
    }
  }, [content, isRendered]);

  const initVditor = useCallback(() => {
    if (!vditor) {
      vditor = new Vditor('markdown', {
        toolbarConfig: {
          pin: true
        },
        // mode: 'ir',
        toolbar: vditorOption,
        input: (val: string) => {
          changeVal(val);
        },
        value: content,
        after: () => {
          setIsRendered(true);
        },
        placeholder: '请输入正文',
        hint: {
          emoji: {
            ...emojiObj
          }
        },
        // preview: {
        //   markdown: {
        //     autoSpace: true,
        //     // chinesePunct: true,
        //     toc: false,
        //     codeBlockPreview: true,
        //     sanitize:true
        //     // setext: true
        //   },
        //   // theme:'Dark',
        //   mode:'editor',
        //   hljs: {
        //     style: 'igor'
        //   },
        //   transform: (html: string) => {
        //      return xss(html)
        //   }
        // },
        cache: {
          enable: false
        },
        upload: {
          max: 5 * 1024 * 1024,
          accept: 'image/*',
          handler: (files: File[]) => {
            const formData = new FormData();
            for (const i in files) {
              formData.append('file', files[i]);
            }
            ajax
              .ajax({
                method: 'POST',
                url: `${process.env.REACT_APP_PUBLIC_URL}/api/file/multi-upload`,
                data: formData
              })
              .then(res => {
                if (res.code === 0) {
                  const fileArr = res.result;
                  fileArr.forEach((item: FileDTO) => {
                    vditor && vditor.insertValue(`![${item.fileId}](${item.previewUrl})`, true);
                  });
                  vditor && changeVal(vditor.getValue());

                  /** 二次上传同一张图片不生效 */
                  const ele = document.querySelector('.vditor-toolbar input') as HTMLInputElement;
                  ele.value = '';
                } else {
                  message.error(res.message);
                }
              })
              .catch(e => {
                console.warn(e);
              });
            return null;
          }
        },
      });
    }
  }, [changeVal, content]);

  useEffect(() => {
    initVditor();
  }, [initVditor]);

  useEffect(() => {
    return () => {
      vditor = undefined;
    };
  }, []);

  return (
    <div className="vditor-edit">
      <div className={`ql-container ${className} vditor`} id="markdown" />
    </div>
  );
};

export default SFCVditor;
